'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nextMenu = require('../../next-menu/lib/index.js');

var _nextMenu2 = _interopRequireDefault(_nextMenu);

var _nextIcon = require('../../next-icon/lib/index.js');

var _nextIcon2 = _interopRequireDefault(_nextIcon);

var _nextBalloon = require('../../next-balloon/lib/index.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
 * Nav.Item
 * @description 继承自`Menu.Item`的能力请查看`Menu.Item`文档
 */
var Item = (_temp = _class = function (_Menu$Container) {
    _inherits(Item, _Menu$Container);

    function Item() {
        _classCallCheck(this, Item);

        return _possibleConstructorReturn(this, _Menu$Container.apply(this, arguments));
    }

    Item.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            children = _props.children,
            icon = _props.icon,
            className = _props.className,
            others = _objectWithoutProperties(_props, ['children', 'icon', 'className']);

        var prefix = this.context.prefix || this.props.prefix;
        var props = {
            hasSelectedIcon: false
        };
        var childrenEl = children;

        var cls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'nav-item', true), _defineProperty(_classNames, className, !!className), _classNames));

        var iconEl = typeof icon === 'string' ? _react2['default'].createElement(_nextIcon2['default'], { type: '' + icon, size: 'xs', className: prefix + 'nav-icon' }) : icon;

        if (iconEl) {
            if (this.context.iconOnly && !(others.parent && others.parent.props.mode === 'popup')) {
                childrenEl = iconEl;
                props.indentSize = 0;
                delete others.indentSize;
                if (this.context.hasTooltip) {
                    var item = _react2['default'].createElement(
                        _nextMenu2['default'].Item,
                        _extends({ ref: 'item' }, props, others, { className: cls }),
                        childrenEl
                    );
                    return _react2['default'].createElement(_nextBalloon.Tooltip, { trigger: item, align: 'r', text: children });
                }
            } else {
                childrenEl = _react2['default'].createElement(
                    'span',
                    null,
                    iconEl,
                    ' ',
                    children
                );
            }
        }

        return _react2['default'].createElement(
            _nextMenu2['default'].Item,
            _extends({ ref: 'item' }, props, others, { className: cls }),
            childrenEl
        );
    };

    return Item;
}(_nextMenu2['default'].Container), _class.propTypes = {
    /**
     * 样式前缀
     */
    prefix: _propTypes2['default'].string,
    /**
     * 自定义图标，可以使用Icon的type, 也可以使用组件`<Icon type="your type"/>`
     */
    icon: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node])
}, _class.defaultProps = {
    prefix: 'next-'
}, _class.contextTypes = {
    iconOnly: _propTypes2['default'].bool,
    hasTooltip: _propTypes2['default'].bool,
    prefix: _propTypes2['default'].string
}, _temp);
exports['default'] = Item;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-nav/lib/item.js
// module id = 420
// module chunks = 0